import { Box, Flex, Stack, Text } from '@chakra-ui/react';
import { ManualOverride } from '@diamond/shared/types';
import { CountCharacterField, Dropdown, TextField } from '@diamond/shared/ui';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { FieldError, useFormContext } from 'react-hook-form';

import { BANK_OPTIONS } from './banks.constant';

interface ManualFallbackFieldsProps {
  fieldIndex: number;
}

export const ManualFallbackFields = ({
  fieldIndex,
}: ManualFallbackFieldsProps) => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<{ manual_overrides: ManualOverride[] }>();

  const bankFieldName =
    `manual_overrides.${fieldIndex}.sender_bank` as const;
  const nameFieldName =
    `manual_overrides.${fieldIndex}.sender_account_name` as const;

  const bankError = errors?.manual_overrides?.[fieldIndex]
    ?.sender_bank as FieldError | undefined;
  const bankErrors: Record<string, FieldError | undefined> = {
    [bankFieldName]: bankError,
  };

  return (
    <Stack spacing={3}>
      <Flex
        align="flex-start"
        gap="8px"
        bg="#FFF3CD"
        borderRadius="4px"
        px="12px"
        py="10px"
      >
        <Box as={InfoOutlined} color="orange.500" boxSize="16px" flexShrink={0} mt="1px" />
        <Text fontSize="12px" color="gray.700">
          OCR tidak dapat membaca data pengirim. Lengkapi data secara manual.
        </Text>
      </Flex>

      <Dropdown
        name={bankFieldName}
        label="Nama Bank"
        register={register}
        errors={bankErrors}
        items={BANK_OPTIONS}
      />

      <Box>
        <TextField
          name={nameFieldName}
          label="Nama Pemilik Rekening"
          register={register}
          errors={errors}
          placeholder="Masukkan nama pemilik rekening"
          border="1px solid"
          borderColor="gray.33"
          maxLength={100}
        />
        <CountCharacterField
          control={control}
          name={nameFieldName}
          maxLength={100}
        />
      </Box>
    </Stack>
  );
};
